const defaultGameSettings = {
  soundEffects: true,
  autoPlayTts: true,
  darkMode: false
};

export default defaultGameSettings;
